import React from "react";
import Multiselect from "./MultiSelect";
import { useVendors } from "../../hooks/useVendors";

// Read-only vendor dropdown shown on Alliance Manager edit forms (vendor cannot change on edit).
// vendorIds: candidate ids in priority order (e.g. record's created_by, then its executive's created_by)
const LockedVendorSelect = ({ vendorIds, className = "col col-5" }) => {
  const { vendors, isLoading } = useVendors();
  const vendor = vendorIds
    ?.map((id) => vendors?.find((item) => item?.id == id))
    .find(Boolean);

  return (
    <section className={className}>
      <label className="label">Vendor</label>
      <Multiselect
        options={vendor ? [vendor] : []}
        value={vendor || null}
        getOptionLabel={(option) => option?.name}
        getOptionValue={(option) => option?.id}
        placeholder="Vendor"
        isMulti={false}
        isDisabled
        isLoading={isLoading}
      />
    </section>
  );
};

export default LockedVendorSelect;
